import React, { useEffect, useMemo, useState } from "react";
import { Row, Col, Form, Card } from "react-bootstrap";
import { connect } from "react-redux";
import { setHeading } from "../../../accounts/account.actions";
import { AddMasterControlApi, GetMasterControlApi } from "./MasterControl.action";
import { GetLevelFourDropDownApi } from "../../AccountsModule/LevelFour/LevelFourAction";
import { GlobalSpinner, showSuccessAlert, showErrorAlert } from "../../../../../global/globalFunctions";
import Select from "react-select";
import SendIcon from "@mui/icons-material/Send";
import Button from "@mui/material/Button";


const AccountsIntegration = (props) => {
  const [accounts, setAccounts] = useState({
    invoiceSalesAccount: null,
    cashReceiveAccount: null,
    cashReceiveDiscountAccount: null,
    orderSaleAccount: null,
    orderDiscountAccount: null,
    orderTradeDiscountAccount: null,
    orderTaxAccount: null,
    receivingPurchaseAccount: null,
    receivingDiscountAccount: null,
    receivingLeakDiscountAccount: null,
    receivingFreightAccount: null,
    receivingTaxAccount: null,
    receivingAdjustmentAccount: null,
  });

  const accountOptions = useMemo(() => {
    return props.levelFourDropDownList?.map((x) => ({
      value: x._id,
      label: x.levelFourName,
    })) || [];
  }, [props.levelFourDropDownList]);

  useEffect(() => {
    if (props.masterControlDataList?.length) {
      const data = props.masterControlDataList[0];

      setAccounts({
        invoiceSalesAccount: data.invoiceSalesAccount
          ? { value: data.invoiceSalesAccount._id, label: data.invoiceSalesAccount.levelFourName }
          : null,

        cashReceiveAccount: data.cashReceiveAccount
          ? { value: data.cashReceiveAccount._id, label: data.cashReceiveAccount.levelFourName }
          : null,

        cashReceiveDiscountAccount: data.cashReceiveDiscountAccount
          ? { value: data.cashReceiveDiscountAccount._id, label: data.cashReceiveDiscountAccount.levelFourName }
          : null,

        orderSaleAccount: data.orderSaleAccount
          ? { value: data.orderSaleAccount._id, label: data.orderSaleAccount.levelFourName }
          : null,

        orderDiscountAccount: data.orderDiscountAccount
          ? { value: data.orderDiscountAccount._id, label: data.orderDiscountAccount.levelFourName }
          : null,

        orderTradeDiscountAccount: data.orderTradeDiscountAccount
          ? { value: data.orderTradeDiscountAccount._id, label: data.orderTradeDiscountAccount.levelFourName }
          : null,

        orderTaxAccount: data.orderTaxAccount
          ? { value: data.orderTaxAccount._id, label: data.orderTaxAccount.levelFourName }
          : null,

        receivingPurchaseAccount: data.receivingPurchaseAccount
          ? { value: data.receivingPurchaseAccount._id, label: data.receivingPurchaseAccount.levelFourName }
          : null,

        receivingDiscountAccount: data.receivingDiscountAccount
          ? { value: data.receivingDiscountAccount._id, label: data.receivingDiscountAccount.levelFourName }
          : null,

        receivingLeakDiscountAccount: data.receivingLeakDiscountAccount
          ? { value: data.receivingLeakDiscountAccount._id, label: data.receivingLeakDiscountAccount.levelFourName }
          : null,

        receivingFreightAccount: data.receivingFreightAccount
          ? { value: data.receivingFreightAccount._id, label: data.receivingFreightAccount.levelFourName }
          : null,

        receivingTaxAccount: data.receivingTaxAccount
          ? { value: data.receivingTaxAccount._id, label: data.receivingTaxAccount.levelFourName }
          : null,

        receivingAdjustmentAccount: data.receivingAdjustmentAccount
          ? { value: data.receivingAdjustmentAccount._id, label: data.receivingAdjustmentAccount.levelFourName }
          : null,

      });
    }
  }, [props.masterControlDataList]);

  const handleChange = (field) => (selected) => {
    setAccounts((prev) => ({
      ...prev,
      [field]: selected,
    }));
  };

  const saveAccounts = () => {
    props.AddMasterControlApi(
      {
        invoiceSalesAccount: accounts.invoiceSalesAccount?.value || null,
        cashReceiveAccount: accounts.cashReceiveAccount?.value || null,
        cashReceiveDiscountAccount: accounts.cashReceiveDiscountAccount?.value || null,
        orderSaleAccount: accounts.orderSaleAccount?.value || null,
        orderDiscountAccount: accounts.orderDiscountAccount?.value || null,
        orderTradeDiscountAccount: accounts.orderTradeDiscountAccount?.value || null,
        orderTaxAccount: accounts.orderTaxAccount?.value || null,
        receivingPurchaseAccount: accounts.receivingPurchaseAccount?.value || null,
        receivingDiscountAccount: accounts.receivingDiscountAccount?.value || null,
        receivingLeakDiscountAccount: accounts.receivingLeakDiscountAccount?.value || null,
        receivingFreightAccount: accounts.receivingFreightAccount?.value || null,
        receivingTaxAccount: accounts.receivingTaxAccount?.value || null,
        receivingAdjustmentAccount: accounts.receivingAdjustmentAccount?.value || null,
      },
      showSuccessAlert,
      showErrorAlert
    );
  };

  useEffect(() => {
    props.setHeading("Account Integration");
    props.GetLevelFourDropDownApi();
    props.GetMasterControlApi();
  }, []);

  if (props.isAddingMasterControl || props.isFetchingLevelFourDropDown || props.isFetchingMasterControl) {
    return <GlobalSpinner />;
  }

  const sections = [
    {
      title: "SECTION-1 INVOICE",
      badge: "ACCOUNTS",
      fields: [
        {
          label: "Invoice Sales Account",
          field: "invoiceSalesAccount",
          placeholder: "Select Invoice Sales Account",
        },
      ],
    },
    {
      title: "SECTION-2 PAYMENT RECEIVED",
      badge: "STORE",
      fields: [
        {
          label: "Cash Receive Account",
          field: "cashReceiveAccount",
          placeholder: "Select Cash Receive Account",
        },
        {
          label: "Cash Receive Discount Account",
          field: "cashReceiveDiscountAccount",
          placeholder: "Select Discount Account",
        },
      ],
    },
    {
      title: "SECTION-3 STORE ORDER BOOKING",
      badge: "STORE",
      fields: [
        {
          label: "Order Sale Account",
          field: "orderSaleAccount",
          placeholder: "Select Order Sale Account",
        },
        {
          label: "Order Discount Account",
          field: "orderDiscountAccount",
          placeholder: "Select Discount Account",
        },
        {
          label: "Order Trade Discount Account",
          field: "orderTradeDiscountAccount",
          placeholder: "Select Trade Discount Account",
        },
        {
          label: "Order Tax Account",
          field: "orderTaxAccount",
          placeholder: "Select Tax Account",
        },
      ],
    },
    {
      title: "SECTION-4 RECEIVING",
      badge: "STORE",
      fields: [
        {
          label: "Stock Purchase Account",
          field: "receivingPurchaseAccount",
          placeholder: "Select Stock Purchase Account",
        },
        {
          label: "Receiving Sales Tax Account",
          field: "receivingFreightAccount",
          placeholder: "Select Freight Account",
        },
        {
          label: "Receiving Discount Account",
          field: "receivingDiscountAccount",
          placeholder: "Select Discount Account",
        },
        {
          label: "Receiving Leak Discount Account",
          field: "receivingLeakDiscountAccount",
          placeholder: "Select Leak Discount Account",
        },
        {
          label: "Receiving Tax Account",
          field: "receivingTaxAccount",
          placeholder: "Select Tax Account",
        },
        {
          label: "Receiving Adjustment Account",
          field: "receivingAdjustmentAccount",
          placeholder: "Select Adjustment Account",
        },
      ],
    },
  ];

  return (
    <Form>
      {sections.map((section, index) => (
        <Card key={index} className="mb-4 shadow-sm">
          {/* <Card.Header> <h5 className="mb-0">{section.title}</h5></Card.Header> */}
          <div style={{ display: "flex", alignItems: "center", gap: 10, padding: "0.75rem 1.25rem", background: '#E6F1FB', borderBottom: `0.5px solid #B5D4F4` }} >
            <div style={{ width: 8, height: 8, borderRadius: "50%", background: '#185FA5' }} />
            <span style={{ fontSize: 13, fontWeight: 600, color: '#0C447C', letterSpacing: "0.04em", textTransform: "uppercase" }} >
              {section.title}
            </span>
            <span style={{ marginLeft: "auto", fontSize: 12, color: '#185FA5', background: '#B5D4F4', borderRadius: 4, padding: "2px 8px", fontWeight: 500, }} >
              {section.badge}
            </span>
          </div>

          <Card.Body>
            <Row>
              {section.fields.map((item, i) => (
                <Col>
                  <Form.Group className="mb-3">
                    <Form.Label><b>{item.label} *</b></Form.Label>
                    <Select
                      placeholder={item.placeholder}
                      options={accountOptions}
                      value={accounts[item.field]}
                      onChange={handleChange(item.field)}
                    />
                  </Form.Group>
                </Col>
              ))}
            </Row>
          </Card.Body>
        </Card>
      ))}

      <div className="sendDiv">
        <Button variant="contained" endIcon={<SendIcon />} size="large" onClick={saveAccounts}>UPDATE</Button>
      </div>

    </Form>
  );
};

const mapDispatchToProps = (dispatch) => ({
  AddMasterControlApi: (data, showSuccessAlert, showErrorAlert) => dispatch(AddMasterControlApi(data, showSuccessAlert, showErrorAlert)),
  GetLevelFourDropDownApi: () => dispatch(GetLevelFourDropDownApi()),
  GetMasterControlApi: () => dispatch(GetMasterControlApi()),
  setHeading: (data) => dispatch(setHeading(data)),
});

const mapStateToProps = (state) => ({
  isAddingMasterControl: state.MasterControlReducer.isAddingMasterControl,
  isFetchingLevelFourDropDown: state.LevelFourReducer.isFetchingLevelFourDropDown,
  levelFourDropDownList: state.LevelFourReducer.levelFourDropDownList,
  masterControlDataList: state.MasterControlReducer.masterControlDataList,
  isFetchingMasterControl: state.MasterControlReducer.isFetchingMasterControl,
});

export default connect(mapStateToProps, mapDispatchToProps)(AccountsIntegration);